import * as Yup from 'yup';

Yup.addMethod(Yup.string, 'isAlphaNumeric', function () {
    const errorMessage = 'This field can only include alphanumeric characters.';
    return this.matches(/^[a-z0-9]+$/i, errorMessage);
});
import passwordValidationRules from '@nexxt/common/firebase/auth/passwordValidation';

export function getQuestionLabelValidationSchema() {
    return Yup.object().shape({
        question_label: Yup.string()
            .trim()
            .min(1, 'Your question label must be at least one character')
            .required('Please enter a question label.')
    });
}

export function getProfileValidationSchema() {
    return Yup.object().shape({
        firstName: Yup.string()
            .trim()
            .isAlphaNumeric()
            .required('Please enter your first name.'),
        lastName: Yup.string().trim().required('Please enter your last name.')
    });
}

export function passwordValidationSchema() {
    return Yup.object().shape({
        ...passwordValidationRules
    });
}

export function createUserValidationSchema() {
    return Yup.object().shape({
        email: Yup.string()
            .email('Please enter valid email address.')
            .trim()
            .required('Please enter valid email address.')
            .matches(
                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                `You can't use numbers or special symbols.`
            ),
        firstName: Yup.string()
            .matches(/^[A-Za-z.\s_0-9-]+$/, "You can't use special symbols")
            .required('Please enter their first name.'),
        lastName: Yup.string().matches(
            /^[A-Za-z.\s_0-9-]+$/,
            "You can't use special symbols"
        ),
        company: Yup.string()
            .matches(
                /^[a-zA-Z0-9_@.\/#$&()\\\-`.+,"'\s]*$/,
                "You can't use special symbols"
            )
            .required('Please enter the company name.')
    });
}

export function addNewProjectValidationSchema() {
    return Yup.object().shape({
        projectName: Yup.string()
            .trim()
            .min(2, 'Your project name must contain atleast 2 characters.')
            .required('Please enter project name.'),
        codeName: Yup.string()
            .min(2, 'Your project url must contain atleast 2 characters.')
            .required('Please enter project url.')
            .matches(
                /^[a-zA-Z](?:[_\-]*[A-Za-z0-9])*$/, // /^[a-zA-Z][A-Za-z0-9]+(?:[ _-][A-Za-z0-9]+)*$/,
                // /^[A-Za-z.\s_-]+$/,
                `Only letters, numbers, dash, underscore are allowed. Must start with letter not ending with dash/underscore.`
            )
    });
}

export function botSettingsValidationSchema() {
    return Yup.object().shape({
        pageTitle: Yup.string()
            .trim()
            .min(2, 'Your project title must contain atleast 2 characters.')
            .required('Please enter project title.'),
        sessionTimeout: Yup.number().required('Please enter session timeout')
    });
}

export function createTenantValidationSchema() {
    return Yup.object().shape({
        tenantName: Yup.string()
            .trim()
            .min(2, 'Your account name must contain atleast 2 characters.')
            .required('Please enter tenant name.')
            .matches(
                /^[A-Za-z][A-Za-z.\s_-]*$/,
                `You can not start with _ or -. You can't use numbers or special symbols.`
            ),
        tenantURL: Yup.string()
            .required('Please enter account url.')
            .matches(
                /^[a-zA-Z](?:[_\-]*[A-Za-z0-9])*$/,
                `You can not start with _ or -. You can't use special symbols.`
            )
    });
}

export function duplicateProjectValidationSchema() {
    return Yup.object().shape({
        projectName: Yup.string()
            .trim()
            .min(2, 'Your project name must contain atleast 2 characters.')
            .required('Please enter project name.')
    });
}

export function duplicateOptionPackValidationSchema() {
    return Yup.object().shape({
        label: Yup.string()
            .trim()
            .required('Please enter option group label.')
            .matches(
                /^[A-Za-z.\s_-]+$/,
                `You can't use numbers or special symbols.`
            )
    });
}

export function duplicateQuestionValidationSchema() {
    return Yup.object().shape({
        questionTitle: Yup.string()
            .trim()
            .required('Please enter question title.')
    });
}

export function forgotPasswordValidationSchema() {
    return Yup.object().shape({
        email: Yup.string()
            .email('Please enter valid email address.')
            .trim()
            .required('Please enter valid email address.')
            .matches(
                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                `You can't use numbers or special symbols.`
            )
    });
}

export function requetDemoValidationSchema() {
    return Yup.object().shape({
        email: Yup.string()
            .email('Please enter valid email address.')
            .trim()
            .required('Please enter valid email address.')
            .matches(
                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                `You can't use numbers or special symbols.`
            ),
        firstName: Yup.string()
            .trim()
            .required('Please enter your first name')
            .matches(
                /^[A-Za-z.\s_-]+$/,
                `You can't use numbers or special symbols.`
            ),
        lastName: Yup.string()
            .trim()
            .required('Please enter your last name')
            .matches(
                /^[A-Za-z.\s_-]+$/,
                `You can't use numbers or special symbols.`
            ),
        phoneNum: Yup.string()
            .trim()
            .required('Please enter your last name')
            .matches(
                /^\(?([0-9]{3})\)?[-.●]?([0-9]{3})[-.●]?([0-9]{4})$/,
                `Please enter valid phone number.`
            ),
        company: Yup.string()
            .trim()
            .required('Please enter your last name')
            .matches(/^[A-Za-z.\s_-]+$/, `Please enter your company name`)
    });
}
